<template>
    <div>
        <h1>{{ $t("templates.heading") }}</h1>
        <router-link :to="{ name: 'createCalculationTemplate' }" class="btn btn-primary">{{ $t("utils.create") }}</router-link>
        <table class="table">
            <tr>
                <th>{{ $t("templates.name") }}</th>
                <th>{{ $t("utils.actions") }}</th>
            </tr>
            <tr v-for="(template, i) in templates">
                <td>{{ template.name }}</td>
                <td>
                    <router-link :to="{ name: 'templateEdit', params: {id: template.id} }" class="btn btn-primary me-2">{{ $t("utils.edit") }}</router-link>
                    <button class="btn btn-primary me-2" @click="selectTemplate(template.id)">{{ $t("utils.use") }}</button>
                    <button class="btn btn-primary" @click="hide(template.id)">{{ $t("utils.delete") }}</button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            templates: [],
            loading: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/templates").then(function (response) {
                this.templates = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        selectTemplate: function (id) {
            this.$router.push({ name: 'createCalculation' , params: {id: id}});
        },
        hide: function (id) {
            this.$store.getters.api.post("/template/" + id +"/hide").then(function (response) {
                this.loadData();
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>